"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { Overline } from "@repo/ui/overline";
import { NavigationTabs, NavigationTabsList, NavigationTabsTrigger, NavigationTabsContent } from "@repo/ui/navigation-tabs";
import { Actions } from "@/components/common/actions/actions.component";
import { RichTextCondensed } from "@/components/common/rich-text/rich-text-condensed.component";
import type { TextLeftLayoutProps } from "./text-left-layout.types";
export function TextLeftLayout(t0) {
  const $ = _c(27);
  const {
    overline,
    headline,
    body,
    actions,
    tabs,
    children,
    className
  } = t0;
  const hasTabs = tabs && tabs.length > 0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("bg-surface-base-primary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== overline) {
    t2 = overline && <Overline>{overline}</Overline>;
    $[2] = overline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== headline) {
    t3 = headline && <h2 className="typography-mobile-heading-h5 desktop:typography-desktop-heading-h5 text-text-primary">{headline}</h2>;
    $[4] = headline;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== body) {
    t4 = body && <RichTextCondensed richText={body} className="text-text-secondary" />;
    $[6] = body;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== actions) {
    t5 = actions && actions.length > 0 && <Actions actions={actions} buttonVariants={["blue-filled", "blue-outline"]} />;
    $[8] = actions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="col-span-full desktop:col-span-4 flex flex-col gap-4 desktop:gap-6">{t2}{t3}{t4}{t5}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== children || $[16] !== hasTabs || $[17] !== tabs) {
    t7 = hasTabs ? <NavigationTabs defaultValue={tabs[0]?.key}><NavigationTabsList className="overflow-x-scroll w-full">{tabs.map(_temp)}</NavigationTabsList>{tabs.map(_temp2)}</NavigationTabs> : children;
    $[15] = children;
    $[16] = hasTabs;
    $[17] = tabs;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <div className="col-span-full desktop:col-span-7 desktop:col-start-6">{t7}</div>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t8) {
    t9 = <div className="container-grid py-16 desktop:py-28"><div className="col-span-full grid grid-cols-subgrid gap-y-12 desktop:gap-y-0">{t6}{t8}</div></div>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t1 || $[25] !== t9) {
    t10 = <section className={t1} data-testid="text-left-layout">{t9}</section>;
    $[24] = t1;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp2(tab_0) {
  return <NavigationTabsContent key={tab_0.key} value={tab_0.key} className="mt-8 desktop:mt-12">{tab_0.content}</NavigationTabsContent>;
}
function _temp(tab) {
  return <NavigationTabsTrigger key={tab.key} value={tab.key} size="sm" className="desktop:h-12 desktop:px-4 desktop:py-3 desktop:gap-2 desktop:typography-component-sm-medium">{tab.label}</NavigationTabsTrigger>;
}